import React, { useContext } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Edit3, MoreVertical } from "lucide-react";
import { TableContext } from "../../index";
import { Checkbox } from "../../view/Checkbox";
import { deepCopy } from "../../utils";

const EMPTY_VALUE = "-";
const displayValue = (value) => value === null || value === undefined || value === "" ? EMPTY_VALUE : value;
const displayAuthorization = (value) => value === "BLOCKED" ? "DENIED" : value;

function Pill({ value, type }) {
    if (!value) return EMPTY_VALUE;
    const className = type === "danger" ? "oct_severity-badge-v2 severity-high" : "oct_severity-badge-v2 severity-low";
    return <span className={className}>{value}</span>;
}

function DeviceAuthorizationTableRow({ data, index, onEdit }) {
    const { config, setConfig } = useContext(TableContext);
    const [anchorEl, setAnchorEl] = React.useState(null);

    const onCheckboxChange = () => {
        const selectedRows = deepCopy(config.selected || []);
        if (selectedRows.includes(data.id)) {
            selectedRows.splice(selectedRows.indexOf(data.id), 1);
        } else {
            selectedRows.push(data.id);
        }
        setConfig({ ...config, selected: selectedRows });
    };

    return (
        <tr key={index}>
            <td>
                <Checkbox checked={(config.selected || []).includes(data.id)} onClick={onCheckboxChange} />
            </td>
            <td>{displayValue(data.deviceName || data.device || data.deviceId)}</td>
            <td>{displayValue(data.username)}</td>
            <td>{displayValue(data.action)}</td>
            <td>
                <Pill value={displayAuthorization(data.authorization)} type={data.authorization === "BLOCKED" ? "danger" : "success"} />
            </td>
            <td>{data.alertEnabled ? "Yes" : "No"}</td>
            <td className="oct_table-actions-cell-v2">
                <button className="oct_dropdown-trigger-v2" onClick={(event) => setAnchorEl(event.currentTarget)}>
                    <MoreVertical className="oct_icon" />
                </button>
                <Menu className="oct_menu-v2" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
                    <MenuItem className="oct_menu-item-v2" onClick={() => {
                        setAnchorEl(null);
                        onEdit(data);
                    }}>
                        <Edit3 className="oct_icon" /> Edit
                    </MenuItem>
                </Menu>
            </td>
        </tr>
    );
}

export default DeviceAuthorizationTableRow;
